import React from "react";
import { Link } from "react-router-dom";
import useCookiesCheck from "../../utils/useCookiesCheck";
import { useTranslation } from "react-i18next";

const MyLmxThanksMsg = () => {
  useCookiesCheck();
  const { t } = useTranslation();

  return (
    <div className="container pt-4">
      <div className="row justify-content-center text-center">
        <div className="col-12 col-lg-4">
          <h2>{t("other.thankYou")}</h2>
          <div>{t("other.uploadFileConfirmMessage")}</div>
          <Link to="/booking-details">OK</Link>
        </div>
      </div>
    </div>
  );
};

export default MyLmxThanksMsg;
